<template>
  <v-card class="mt-2 mb-2 ml-2 mr-2 ">
    <center>
      <section class="px-5 pt-5 pb-5 ">
        <div>From: {{ bookingTransfer.fromCoach.fullName }}</div>
        <div>To: {{ bookingTransfer.toCoach.fullName }}</div>
        <div>Status: {{ bookingTransfer.transferStatus.description }}</div>
        <v-btn
          v-if="bookingTransfer.transferStatusID==1"
          color="primary"
          size="x-small"
          class="mt-2"
          @click="handleCancel"
        >
          Cancel
        </v-btn>
      </section>
    </center>
  </v-card>
</template>
<script setup>
import { ref, toRefs } from 'vue'
import { cancelBookingTransfer } from '@/api/bookedCourse'

const props = defineProps({
  bookingTransfer: {
    type: Object,
    default() {
      return {
        fromCoach: {
          fullName: 'Jason',
        },
        toCoach: {
          fullName: 'Anthony',
        },
        transferStatus: {
          description: 'pending',
        },
      }
    },
  },
})
const { bookingTransfer } = toRefs(props)

const emit = defineEmits(['cancel', 'loading'])

function handleCancel(e) {
  console.log('handleCancel clicked', bookingTransfer.value)
  emit('loading')
  if (window.confirm('Are you sure you want to cancel this transfer record?')) {
  // If the user clicks "OK", execute the code inside this block
    cancelBookingTransfer(bookingTransfer.value).then(response => {
      console.log('cancelBookingTransfer', response)
      emit('cancel', bookingTransfer)
    })
  }
}
</script>
<style scoped>
.item-card{
  display: inline-block !important;
  white-space: nowrap;
  cursor: pointer;
}
.nowarp{
  white-space: nowrap;
}
.course-content{
  padding-left: 5px;
  /* float: right; */
}
</style>
